import MapIcon from "@mui/icons-material/Map";
import "./MapPlaceholder.css";

const MapPlaceholder = () => (
  <div className="map-placeholder">
    <MapIcon className="map-placeholder-icon" />
    <h2>Carte des alertes</h2>
    <p>La carte interactive de surveillance et d'alerte sera bientôt disponible ici.</p>
  </div>
);

export default MapPlaceholder;
